import { createContext, useContext, type ReactNode } from 'react'
import { useNotifications } from '@/features/notifications'
import type { NotificationDocument } from '@/types'

interface NotificationsContextValue {
  notifications: Array<NotificationDocument & { id: string }>
  loading: boolean
  error: string | null
  unreadCount: (uid: string) => number
  markRead: (id: string, uid: string) => Promise<void>
  resolve: (id: string, resolvedByUid: string) => Promise<void>
}

const NotificationsContext = createContext<NotificationsContextValue | null>(null)

function NotificationsProvider({ children }: { children: ReactNode }) {
  const value = useNotifications()
  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  )
}

function useNotificationsContext(): NotificationsContextValue {
  const ctx = useContext(NotificationsContext)
  if (!ctx) throw new Error('useNotificationsContext must be used within NotificationsProvider')
  return ctx
}

export { NotificationsContext, NotificationsProvider, useNotificationsContext }
